import { FC, useMemo, useState, useEffect } from 'react';
import dayjs, { Dayjs } from 'dayjs';
// Utilities
import { getTimeRemaining } from 'utilities/Utilities';
// i18next
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  startsDate: string;
  endsDate: string;
}

let countdownInterval:any;
const milliseconds = 1000;

let now = dayjs();

const TextCountdown:FC<Props> = ({
  // Props
  startsDate, endsDate
}) => {
  const { t } = useTranslation();

  const startDate = useMemo(() => {
    return dayjs(Number(startsDate));
    // eslint-disable-next-line
  }, [startsDate]);
  const endDate = useMemo(() => {
    return dayjs(Number(endsDate));
  }, [endsDate]);

  const [ startCountdown, setStartCountdown ] = useState(false);
  const [ label, setLabel ] = useState<string>(t('components.countdown.quizStarts'));
  const [ finalDate, setFinalDate ] = useState<Dayjs | null>(null);
  const [ days, setDays ] = useState(0);
  const [ hours, setHours ] = useState(0);
  const [ minutes, setMinutes ] = useState(0);

  useEffect(() => {
    if ( now.isBefore(startDate) ){
      setFinalDate(startDate);
      setStartCountdown(true);
    } else if ( now.isAfter(endDate) ){
      setLabel(t('components.countdown.quizEnded'));
    } else {
      setLabel(t('components.countdown.quizEndsIn'));
      setStartCountdown(true);
      setFinalDate(endDate);
    }
    // eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    if ( startCountdown ){
      countdownInterval = setInterval(() => {
        now = dayjs();
        if ( finalDate ){
          if ( now.isAfter(finalDate) ){
            setLabel(t('components.countdown.quizEnded'));
            clearInterval(countdownInterval);
          } else {
            const remaining = getTimeRemaining(now, finalDate);

            setDays(remaining.days);
            setHours(remaining.hours);
            setMinutes(remaining.minutes);
          }
        }
      }, milliseconds);
    }
    // eslint-disable-next-line
  }, [startCountdown]);

  if (!endsDate) return null;
  if ( label === t('components.countdown.quizEnded') ) return (
    <div className="text-center text-sm mb-4 text-primary">
      {label}
    </div>
  )
  return (
    <div className="text-center text-sm mb-4 text-primary">
      <Trans t={t} i18nKey={label} components={{ br: <></> }} />
      {` ${days || '0'} ${t('components.countdown.days')}, `}{`${hours || '0'} ${t('components.countdown.hours')}, `}{`${minutes || '0'} ${t('components.countdown.minutes')}`}
    </div>
  )
}

export default TextCountdown;
